import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ark-lib-rop-modal',
  templateUrl: './rop-modal.component.html',
  styleUrls: ['./rop-modal.component.css'],
})
export class RopModalComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
